import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { getMultiSelectDisplayText } from '../../../shared/utils';

@Component({
    selector: 'app-sb-multiselect',
    template: `
        <mat-form-field>
            <mat-label>{{ to.label }}</mat-label>
            <mat-select
                [formControl]="formControl"
                placeholder="{{ to.label }}"
                [multiple]="true"
                [formlyAttributes]="field"
                [class.ng-dirty]="showError"
                [id]="key"
                [required]="to.required"
            >
                <app-sb-multiselect-check-all
                    [model]="form.get(getKey())"
                    [values]="to.options"
                ></app-sb-multiselect-check-all>
                <mat-option *ngFor="let option of to.options" [value]="option.value">
                    {{ option.label | translateEnum }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    `
})
export class SbMultiSelectFormComponent extends FieldType {
    getKey(): Array<string> {
        return [this.key as string];
    }

    getDisplayText(options) {
        return getMultiSelectDisplayText(options, this.formControl);
    }
}
